import { render, staticRenderFns } from "./SettingsLabelDropboxDropdown.vue?vue&type=template&id=559ca6ea&scoped=true"
import script from "./SettingsLabelDropboxDropdown.vue?vue&type=script&lang=js"
export * from "./SettingsLabelDropboxDropdown.vue?vue&type=script&lang=js"
import style0 from "./SettingsLabelDropboxDropdown.vue?vue&type=style&index=0&id=559ca6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559ca6ea",
  null
  
)

export default component.exports